module.exports = __webpack_public_path__ + "static/media/manPc.6e6a1f55.png";